module.exports = "/_next/static/media/4484de6ef486bf46f323ac050c483b67.svg";